import type { ReactNode } from 'react';
import { Form } from 'formik';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const OffReportFilterForm = ({ children, onReset }: { children: ReactNode; onReset: () => void }) => {
    const { t } = useTranslation('common');
    return (
        <Form className="off-filter-form d-flex flex-column h-100">
            <div className="off-filter-content px-3">{children}</div>
            <div className="p-3 offcanvas-footer off-filter-footer">
                <div className="d-flex justify-content-end gap-2">
                    <Button type="button" variant="secondary" onClick={onReset}>{t('buttons.reset')}</Button>
                    <Button type="submit" variant="info" className="min100px">{t('buttons.apply')}</Button>
                </div>
            </div>
        </Form>
    );
};

export default OffReportFilterForm;
